import { render } from "./update_data.vue?vue&type=template&id=680ae6c2&scoped=true"
import script from "./update_data.vue?vue&type=script&lang=js"
export * from "./update_data.vue?vue&type=script&lang=js"

import "./update_data.vue?vue&type=style&index=0&id=680ae6c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680ae6c2"]])

export default __exports__